import { create } from "zustand"

const useFetchTickets = create((set) => ({
  tickets: [],
  ticketsCount: 0,
  loading: true,
  setTickets: (tickets) => set({ tickets: tickets, ticketsCount: tickets.length, loading: false }),
  setTicketsLoading: (loadingState) => set({ loading: loadingState }),
}))

export default useFetchTickets
